import React, { useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import { clearCustomer } from "utils/clearCustomer";

export function usePrompt(message, when) {
  const navigator = React.useContext(NavigationContext).navigator;

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;

    navigator.push = (...args) => {
      const result = window.confirm(message);
      if (result) {
        push(...args);
      }
    };

    // clearCustomer();

    // localStorage.removeItem("customerInfo");
    // localStorage.removeItem("buildingInfo");
    // localStorage.removeItem("isImidChecked");
    // localStorage.removeItem("isAddBuildingChecked");
    // localStorage.removeItem("imidDevices");
    // localStorage.removeItem("tenantData");
    // localStorage.removeItem("addMetersFormData");
    // localStorage.removeItem("isMeterChecked");

    return () => {
      navigator.push = push;
    };
  }, [message, when, navigator]);
}
